module.exports = __webpack_public_path__ + "img/kangaroo.87096b1b.jpg";